import { DataBean } from "../../DataBean";


export class ClinicalDocumentState extends DataBean {

    public async getClinicalDocumentStateConstants(args: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getClinicalDocumentStateConstants_Number", [args]);
    }

}